import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output
} from '@angular/core';

@Directive({
    selector: '[bkButton]'
})
export class ButtonDirective {
    @Input() bkBusy: boolean = false;
    @Output() bkButton = new EventEmitter<unknown>();

    constructor (
        public element: ElementRef
    ) {
        const nativeElement = <HTMLElement>element.nativeElement;

        if ([null, undefined].indexOf(nativeElement.getAttribute('tabindex')) > -1) {
            nativeElement.setAttribute('tabindex', '0');
        }
    }

    @HostListener('click', ['$event'])
    clicked (event: unknown): void {
        if (this.bkBusy) {
            return;
        }
        this.bkButton.emit(event);
    }

    @HostListener('keydown.enter', ['$event'])
    onEnterHandler (event: KeyboardEvent): void {
        if (this.bkBusy) {
            return;
        }
        this.bkButton.emit(event);
    }
}
